// extracted by css-extract-rspack-plugin
export default {"field":"pVsICgo6oXIzjkq7","label":"hV01EI27OEoMoDto","datePicker":"X2ouzs5LfQkb89WW"};